var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess11X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D64C093C-8683-478A-9AD7-11F673FED97E@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0 C16.316857,0 21,4.68314303 21,10.5 C21,16.316857 16.316857,21 10.5,21 C4.68314303,21 0,16.316857 0,10.5 C0,4.68314303 4.68314303,0 10.5,0 Z M16.399139,7.13049272 L15.3979369,6.05489245 C15.2134555,5.85670252 14.9145332,5.85670252 14.7306772,6.05489245 L8.72971802,12.5017758 L5.87494742,9.41337199 C5.69046607,9.21518206 5.39216912,9.21518206 5.20768778,9.41337199 L4.20711101,10.4889723 C4.02262966,10.6871622 4.02262966,11.0082971 4.20711101,11.2058152 L8.39264872,15.7326076 C8.57713007,15.9307975 8.87542702,15.9307975 9.05990836,15.7326076 L16.399139,7.84733562 C16.5836203,7.64981752 16.5836203,7.32868265 16.399139,7.13049272 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CondoGo:-Icon-Library",
    transform: "translate(-438.000000, -48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message/...-Filled/Success",
    transform: "translate(438.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/feedback-attention"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-Color",
    fill: "#949494",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess11X);
export default __webpack_public_path__ + "static/media/Success-1@1x.7800d98d8d2fa6f2de9445e7f193cda6.svg";
export { ForwardRef as ReactComponent };